module.exports = __webpack_public_path__ + "img/security2-logo1.7a6542e9.png";